import { createContext } from 'react';
import { useSystemContext } from './SystemContext';

const SystemContext = createContext();

export const SystemContextProvider = ({ children }) => {
    const system = useSystemContext();
    return <SystemContext.Provider value={system}>{children}</SystemContext.Provider>;
};
